/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export default class Cursor
{
  constructor (root, path)
  {
    this.root = root;
    this.path = path;
  }


  rescope (scopeState, scopeCursor)
  {
    return new Cursor(scopeState, this.path.slice(scopeCursor.path.length));
  }


  child (key)
  {
    return new Cursor(this.root, [ ...this.path, key ]);
  }


  get ()
  {
    return this.root.state.getIn(this.path);
  }


  set (value)
  {
    this.root.state = this.root.state.setIn(this.path, value);
  }


  has ()
  {
    return this.root.state.hasIn(this.path);
  }


  remove ()
  {
    this.root.state = this.root.state.removeIn(this.path);
  }


};
